var _style, _g, _defs, _path, _defs2, _path2, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWerkenbijsmithLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 541.1 155.9",
    style: {
      enableBackground: "new 0 0 541.1 155.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1719;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#006EB6;}\n\t.st4{clip-path:url(#SVGID_4_);fill:#FF5000;}\n\t.st5{fill:#006EB6;}\n\t.st6{fill:#FF5000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_1"
  }, /*#__PURE__*/React.createElement("title", null, "logo"), /*#__PURE__*/React.createElement("rect", {
    x: 121.6,
    y: 110.4,
    className: "st0",
    width: 419.5,
    height: 2.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.7,95l-5.4-20.5h2.8l3.1,13.4c0.3,1.4,0.6,2.8,0.9,4.2c0.5-2.2,0.8-3.5,0.9-3.8l3.9-13.8h3.3l2.9,10.4 c0.7,2.6,1.3,5,1.6,7.3c0.3-1.3,0.6-2.8,1-4.5l3.2-13.2h2.7L290,95h-2.6l-4.3-15.6c-0.4-1.3-0.6-2.1-0.6-2.4 c-0.2,0.9-0.4,1.7-0.6,2.4L277.5,95H274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2,95V74.4H313v2.4h-12.1v6.3h11.3v2.4h-11.3v7h12.6V95H298.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,95V74.4h9.1c1.8,0,3.2,0.2,4.2,0.6c1,0.4,1.7,1,2.3,2c0.6,0.9,0.9,2,0.9,3.1c0,1.5-0.5,2.7-1.4,3.7 c-0.9,1-2.4,1.6-4.4,1.9c0.7,0.3,1.3,0.7,1.6,1c0.8,0.7,1.5,1.6,2.3,2.7l3.6,5.6H332l-2.7-4.3c-0.8-1.2-1.4-2.2-2-2.8 c-0.5-0.7-1-1.1-1.4-1.4c-0.4-0.3-0.8-0.4-1.2-0.5c-0.3-0.1-0.8-0.1-1.5-0.1H320V95H317.3z M320,83.5h5.8c1.2,0,2.2-0.1,2.9-0.4 c0.7-0.3,1.2-0.7,1.6-1.2c0.4-0.6,0.5-1.2,0.5-1.8c0-1-0.4-1.8-1.1-2.4c-0.7-0.6-1.8-0.9-3.3-0.9H320V83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.8,95V74.4h2.7v10.2l10.2-10.2h3.7l-8.6,8.3l9,12.2h-3.6l-7.3-10.4l-3.4,3.3V95H337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.1,95V74.4H372v2.4h-12.1v6.3h11.3v2.4h-11.3v7h12.6V95H357.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,95V74.4h2.8l10.8,16.1V74.4h2.6V95h-2.8l-10.8-16.1V95H376.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.7,95V74.4h7.7c1.6,0,2.8,0.2,3.8,0.6s1.7,1.1,2.2,1.9c0.5,0.9,0.8,1.8,0.8,2.7c0,0.9-0.2,1.7-0.7,2.5 s-1.2,1.4-2.2,1.9c1.2,0.4,2.2,1,2.9,1.9c0.7,0.9,1,1.9,1,3.1c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-0.9,1.5-1.5,1.9 c-0.6,0.4-1.3,0.8-2.2,1c-0.9,0.2-2,0.3-3.3,0.3H404.7z M407.4,83.1h4.4c1.2,0,2.1-0.1,2.6-0.2c0.7-0.2,1.2-0.5,1.6-1 s0.5-1.1,0.5-1.8c0-0.7-0.2-1.3-0.5-1.8s-0.8-0.9-1.4-1.1c-0.6-0.2-1.6-0.3-3.1-0.3h-4.1V83.1z M407.4,92.5h5.1 c0.9,0,1.5,0,1.8-0.1c0.6-0.1,1.1-0.3,1.6-0.6c0.4-0.3,0.8-0.6,1-1.1c0.3-0.5,0.4-1.1,0.4-1.7c0-0.8-0.2-1.4-0.6-2s-0.9-1-1.6-1.2 c-0.7-0.2-1.7-0.3-3-0.3h-4.7V92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.4,95V74.4h2.7V95H424.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.5,89.1l2.4-0.3c0.1,1.6,0.4,2.6,0.9,3.2s1.2,0.9,2.2,0.9c0.7,0,1.3-0.2,1.8-0.5s0.8-0.7,1-1.3s0.3-1.4,0.3-2.6V74.4 h2.7v14c0,1.7-0.2,3-0.6,4c-0.4,0.9-1.1,1.7-2,2.2c-0.9,0.5-2,0.7-3.2,0.7c-1.8,0-3.2-0.5-4.1-1.6S430.5,91.2,430.5,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.3,88.4l2.6-0.2c0.1,1,0.4,1.9,0.8,2.5c0.4,0.7,1.1,1.2,2.1,1.6c0.9,0.4,2,0.6,3.1,0.6c1,0,1.9-0.2,2.7-0.5 s1.4-0.7,1.8-1.3s0.6-1.1,0.6-1.8c0-0.6-0.2-1.2-0.6-1.7s-1-0.9-1.8-1.2c-0.6-0.2-1.8-0.5-3.7-1s-3.2-0.9-4-1.3 c-1-0.5-1.7-1.1-2.2-1.9c-0.5-0.8-0.7-1.6-0.7-2.6c0-1,0.3-2,0.9-2.9c0.6-0.9,1.4-1.6,2.6-2c1.1-0.5,2.4-0.7,3.8-0.7 c1.5,0,2.9,0.2,4,0.7c1.2,0.5,2.1,1.2,2.7,2.2c0.6,1,1,2,1,3.2l-2.6,0.2c-0.1-1.3-0.6-2.3-1.4-2.9c-0.8-0.7-2-1-3.6-1 c-1.6,0-2.8,0.3-3.6,0.9c-0.8,0.6-1.1,1.3-1.1,2.2c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.9,1,4.1,1.5c2.2,0.5,3.7,0.9,4.5,1.3 c1.2,0.5,2.1,1.2,2.6,2.1c0.6,0.8,0.9,1.8,0.9,2.9c0,1.1-0.3,2.1-0.9,3.1c-0.6,1-1.5,1.7-2.7,2.3c-1.2,0.5-2.5,0.8-4,0.8 c-1.9,0-3.4-0.3-4.7-0.8c-1.3-0.5-2.2-1.4-3-2.4C453.7,91,453.3,89.7,453.3,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.2,95V74.4h4.1l4.9,14.5c0.4,1.4,0.8,2.4,1,3c0.2-0.7,0.6-1.8,1.1-3.3l4.9-14.3h3.7V95h-2.6V77.8l-6,17.2h-2.4 l-5.9-17.5V95H473.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.6,95V74.4h2.7V95H497.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.3,95V76.9h-6.8v-2.4h16.3v2.4H513V95H510.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.7,95V74.4h2.7v8.4h10.7v-8.4h2.7V95h-2.7v-9.7h-10.7V95H522.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Laag_3",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 39.2,
    y: -19.9,
    transform: "matrix(0.8148 0.5797 -0.5797 0.8148 76.5737 -29.983)",
    width: 92.1,
    height: 249.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.2,0v47.6h61.7C51.1,22,27.7,3.9,0.2,0z M27.5,107.5h72.3c3.3-8.2,5.3-16.9,5.7-25.8h-78L27.5,107.5z  M81.5,51.9H8.7v25.5h77.2C85.7,68.7,84.3,60.1,81.5,51.9z M0.2,155.9c26.2-3.7,48.7-20.3,60.1-44.1H0.2V155.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -40.2,
    y: -66.1,
    transform: "matrix(0.8148 0.5797 -0.5797 0.8148 35.0952 7.4603)",
    width: 92.1,
    height: 249.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,0v47.6h61.7C50.9,22,27.5,3.9,0,0z M27.3,107.5h72.3c3.3-8.2,5.3-16.9,5.7-25.8h-78L27.3,107.5z  M81.3,51.9H8.5v25.5h77.2C85.6,68.7,84.1,60.1,81.3,51.9z M0,155.9c26.1-3.7,48.7-20.2,60.1-44.1H0V155.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Laag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.5,107.4h72.3c3.3-8.2,5.3-16.9,5.7-25.8h-78L27.5,107.4z M0.2,155.8c26.2-3.7,48.7-20.3,60.1-44.1H0.2 V155.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Laag_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0-0.1v47.6h61.7C50.9,21.9,27.5,3.8,0-0.1z M81.3,51.9H8.5v25.5h77.2C85.6,68.7,84.1,60.1,81.3,51.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWerkenbijsmithLogo);
export default __webpack_public_path__ + "static/media/werkenbijsmith-logo.c5b993558575e7c537dea0a5948217d2.svg";
export { ForwardRef as ReactComponent };